// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17eiy","field":"styles_field__dbRdg","fieldCol":"styles_fieldCol__xnjI_","diffCol":"styles_diffCol__2LokR","diff":"styles_diff__37qef"};